module.exports = __webpack_public_path__ + "static/media/toggleMenu.cd68af4a.svg";